/**
 * The Students pages' evidence windows, apart from the rest of the contract
 * (`shared/teacherStudents.ts` re-exports every name here) so a light client
 * module can read a `?window=` without loading the TeacherEvent schema.
 *
 * Pure: no imports.
 */

/**
 * The evidence window both pages read mistakes and own practice through.
 * `last-class` is the start of the class's last occurrence before now; with
 * no occurrence in the lookback it reads as `NO_OCCURRENCE_WINDOW_DAYS`.
 */
export const TEACHER_STUDENTS_WINDOWS = [
  'last-class',
  '7',
  '14',
  '30',
  'all',
] as const;
export type TeacherStudentsWindow = (typeof TEACHER_STUDENTS_WINDOWS)[number];

/** The class page offers every window except `all` (student page only). */
export const CLASS_PAGE_WINDOWS = ['last-class', '7', '14', '30'] as const;
export type ClassPageWindow = (typeof CLASS_PAGE_WINDOWS)[number];

export const DEFAULT_TEACHER_STUDENTS_WINDOW: TeacherStudentsWindow =
  'last-class';

export function isTeacherStudentsWindow(
  value: unknown
): value is TeacherStudentsWindow {
  return (TEACHER_STUDENTS_WINDOWS as readonly unknown[]).includes(value);
}

export function isClassPageWindow(value: unknown): value is ClassPageWindow {
  return (CLASS_PAGE_WINDOWS as readonly unknown[]).includes(value);
}
